import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import { AuthProvider } from "./context/auth/AuthContext";
import { SuperAdminAuthProvider } from "./context/superadmin/SuperAdminAuthContext";

import { Toaster } from "react-hot-toast";

import { routes } from "./routes/routes";
import { queryClient } from "./services/query-client";
import useTenantQuerySession from "./hooks/query/useTenantQuerySession";
import { AlertDialogProvider } from "./components/shared/AlertDialog";

const QuerySessionBoundary = ({ children }) => {
  useTenantQuerySession();
  return children;
};

function App() {
  const router = createBrowserRouter(routes);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <QuerySessionBoundary>
          <SuperAdminAuthProvider>
            <AlertDialogProvider>
              <RouterProvider router={router} />

              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 3000,
                  style: {
                    fontSize: "14px",
                  },
                }}
              />
            </AlertDialogProvider>
          </SuperAdminAuthProvider>
        </QuerySessionBoundary>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
